import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CHANGE_PASSWORD_CONSTANTS } from 'src/app/core/helpers/global/global.constant';
import { User } from 'src/app/core/interfaces/api/user.interface';
import { AuthService } from 'src/app/core/services/api/auth.service';
import { BootstrapModalService } from 'src/app/core/services/ui/bootstrap-modal.service';
import { GlobalService } from 'src/app/core/services/ui/global.service';

@Component({
  selector: 'app-auth-check-form',
  templateUrl: './auth-check-form.component.html',
})
export class AuthCheckFormComponent {
  public authorizationForm: FormGroup = new FormGroup({});
  public showCurrentPassword: boolean = false;
  public profile: User = {} as User;
  constructor(
    private _bsModalService: BootstrapModalService<any>,
    private _profileService: GlobalService,
    private _authService: AuthService,
    private fb: FormBuilder
  ) {
    this.authorizationForm = this.getConfigAuthorizationForm();
    this.loadProfile();
  }

  getConfigAuthorizationForm() {
    return this.fb.group({
      password: ['', [Validators.required]],
    });
  }

  loadProfile(): void {
    this._profileService.profile.subscribe((profile) => {
      this.profile = profile;
    });
  }

  public authorize() {
    const email: string = this.profile!.email as string;
    const password: string = this.authorizationForm.get(
      CHANGE_PASSWORD_CONSTANTS.PASSWORD_FIELD
    )?.value;

    this._authService
      .login({
        email,
        password,
      })
      .subscribe(() => {
        this._bsModalService.updateDataIssued({ password });
        this._bsModalService.closeModal();
      });
  }

  togglePasswordVisibility(): void {
    this.showCurrentPassword = !this.showCurrentPassword;
  }

  cancelForms() {
    this._bsModalService.updateDataIssued(null);
    this._bsModalService.closeModal();
  }
}
